import AutocompleteInput from 'components/form/input/AutocompleteInput'
import React from 'react'
import csvMunicipios from '../../../../municipios'
import TextInput from 'components/form/input/TextInput'

var siglas = {
    "Acre": "AC",
    "Alagoas": "AL",
    "Amapá": "AP",
    "Amazonas": "AM",
    "Bahia": "BA",
    "Ceará": "CE",
    "Distrito Federal": "DF",
    "Espírito Santo": "ES",
    "Goiás": "GO",
    "Maranhão": "MA",
    "Mato Grosso": "MT",
    "Mato Grosso do Sul": "MS",
    "Minas Gerais": "MG",
    "Pará": "PA",
    "Paraíba": "PB",
    "Paraná": "PR",
    "Pernambuco": "PE",
    "Piauí": "PI",
    "Rio de Janeiro": "RJ",
    "Rio Grande do Norte": "RN",
    "Rio Grande do Sul": "RS",
    "Rondônia": "RO",
    "Roraima": "RR",
    "Santa Catarina": "SC",
    "São Paulo": "SP",
    "Sergipe": "SE",
    "Tocantins": "TO"
}
var splitMuni = csvMunicipios.split('\n')

var listM = splitMuni.map(l => {
    let ls = l.split(";");
    return ls[3] + " - " + siglas[ls[1]]
})

export default function SeletorMunicipios({ name = "municipio", label = "Município", ...props }) {
    const { rodada } = props    
    let estadosRestritos = rodada?.restricaoEstado ? rodada.restricaoEstado : null
    if (estadosRestritos && !Array.isArray(estadosRestritos)) {
        estadosRestritos = [estadosRestritos]
    }

    let filterList = listM    
    if (estadosRestritos) {
        filterList = listM.filter(m => {
            for (let index = 0; index < estadosRestritos.length; index++) {
                const e = estadosRestritos[index];
                if (m.endsWith("- " + e)) {
                    return true
                }

            }

            return false
        })
    }
    return (
        <>
            {
                rodada && rodada.rodadaInternacional === "SIM"
                    ? <TextInput sx={{ flex: 1 }} name={name} label={label} required />
                    : <AutocompleteInput
                        // freeSolo
                        name={name} label={label}
                        options={filterList}
                        getOptionLabel={(option) => option ? option : ""}
                        isOptionEqualToValue={(option, value) => option === value}
                        required
                        {...props}
                    />
            }
        </>
    )
}
